/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 03/03/22
 */

/**
 * Pass through array, or convert single value to array
 * @param v
 */
export const toArr = <T>(v: T | T[]): T[] => {
    return Array.isArray(v) ? v : [v];
};

/**
 * Round a number to the next of a given multiple
 * @param n Number to round
 * @param multiple Multiple to round to
 */
export const toNextMultiple = (n: number, multiple: number): number => Math.ceil(n / multiple) * multiple;

/**
 * Get strongly typed array of Object.keys
 * @param obj Object to get keys for
 */
export const typedObjectKeys = <T extends Record<string, unknown>>(obj: T): (keyof T)[] => {
    return Object.keys(obj);
};
